import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SINInputComponent } from '../../form-components/sin-input/sin-input.component';

@Component({
  selector: 'app-member-table-sin-input',
  templateUrl: 'member-table-sin-input-component.html',
  styleUrls: ['member-table-sin-input.component.scss', '../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableSinInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableSinInputComponent extends SINInputComponent {
  @Input() placeholder: string = '*** *** 000';

  public override writeValue(value: string | null): void {
    super.writeValue(value);

    if (!!value) {
      this.showMaskedSIN = true;
      this.showingSIN = false;
      setTimeout(() => {
        this.hiddenSINElement.nativeElement.innerHTML = this.getHiddenSINString();
      });
    } else {
      this.showMaskedSIN = false;
      this.showingSIN = true;
    }
  }

  protected override getHiddenSINString(): string {
    const input = this.value.replace(/\s/g, '') ?? '';
    if (!input) return '';
    const formattedCharacters: string[] = [];
    for (let i = 0; i < input.length; i++) {
      if (i > 0 && i % 3 === 0) {
        formattedCharacters.push(' ');
      }
      if (input.length >= 7 && i >= 6) {
        formattedCharacters.push(input[i]);
      } else {
        formattedCharacters.push(this.showingSIN ? input[i] : '*');
      }
    }
    return formattedCharacters.join('');
  }
}
